"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Ledwall;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactUseinterval = _interopRequireDefault(require("react-useinterval"));

var _gatsbyPluginUtils = require("@pittica/gatsby-plugin-utils");

var _ledwall = require("../helpers/ledwall");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Ledwall({
  lineWidth,
  width,
  height,
  gutter,
  background,
  primary,
  secondary,
  random,
  timing
}) {
  const ref = (0, _react.useRef)();
  const [opacity, setOpacity] = (0, _react.useState)(0.0);
  (0, _react.useEffect)(() => {
    const canvas = ref.current;

    if (typeof window !== "undefined") {
      canvas.width = canvas.parentNode.clientWidth;
      canvas.height = canvas.parentNode.clientHeight;
      window.addEventListener("resize", resize);
      return () => window.removeEventListener("resize", resize);
    } else {
      canvas.width = 1920;
      canvas.height = 1080;
    }
  }, []);
  (0, _reactUseinterval.default)(() => draw(), timing);

  const resize = () => {
    const canvas = ref.current;
    canvas.width = canvas.parentNode.clientWidth;
    canvas.height = canvas.parentNode.clientHeight;
    draw();
  };

  const draw = () => {
    const canvas = ref.current;

    if (canvas.getContext) {
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.lineWidth = lineWidth;
      context.lineCap = "round";
      const {
        r,
        g,
        b
      } = (0, _gatsbyPluginUtils.hexToRgb)(primary);
      let x = gutter;
      let y = gutter;
      let alpha = opacity;

      for (x; x < canvas.width; x += width + gutter) {
        for (y; y < canvas.height; y += height + gutter) {
          context.beginPath();
          context.rect(x, y, width, height);

          if (random) {
            (0, _ledwall.randomize)(context, {
              background,
              primary,
              secondary
            });
          } else {
            alpha += 0.1;

            if (alpha >= 1) {
              alpha = 0;
            }

            context.fillStyle = `rgba(${r}, ${g}, ${b}, ${alpha})`;
          }

          context.fill();
        }

        y = gutter;
      }

      setOpacity(alpha);
    }
  };

  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: ref
  });
}

Ledwall.propTypes = {
  lineWidth: _propTypes.default.number,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  gutter: _propTypes.default.number,
  background: _propTypes.default.string.isRequired,
  primary: _propTypes.default.string.isRequired,
  secondary: _propTypes.default.string.isRequired,
  random: _propTypes.default.bool,
  timing: _propTypes.default.number
};
Ledwall.defaultProps = {
  lineWidth: 2,
  width: 24,
  height: 24,
  gutter: 10,
  random: false,
  timing: 150
};